export const ActionTypes = {
  LOADING: "DUPLICATE_DECISION_LOADING",
  ERROR: "DUPLICATE_DECISION_ERROR",
  SUCCESS: "DUPLICATE_DECISION_SUCCESS",
};
